import { SearchableSelect } from "../../Form/SearchableSelect/SearchableSelect";
import styles from "./CmsFilterRow.module.css";

type FilterOption = {
  value: string;
  label: string;
};

type FilterConfig = {
  key: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: FilterOption[];
  placeholder?: string;
  searchable?: boolean;
};

type ActiveFilter = {
  key: string;
  label: string;
};

type CmsFilterRowProps = {
  filters: FilterConfig[];
  activeFilters?: ActiveFilter[];
  onClearFilter?: (key: string) => void;
  onClearAll?: () => void;
};

export function CmsFilterRow({
  filters,
  activeFilters,
  onClearFilter,
  onClearAll,
}: CmsFilterRowProps) {
  return (
    <>
      <div
        className={styles.filterRow}
        style={{ gridTemplateColumns: filters.map(() => "1fr").join(" ") }}
      >
        {filters.map(filter =>
          filter.searchable ? (
            <div key={filter.key} className={styles.filterItem}>
              <SearchableSelect
                name={filter.key}
                label={filter.label}
                value={filter.value || null}
                onChange={val => filter.onChange(val != null ? String(val) : "")}
                options={filter.options.map(o => ({ value: o.value, label: o.label }))}
                placeholder={filter.placeholder}
              />
            </div>
          ) : (
            <div key={filter.key} className={styles.filterItem}>
              <label htmlFor={`cms-filter-${filter.key}`}>{filter.label}</label>
              <select
                id={`cms-filter-${filter.key}`}
                value={filter.value}
                onChange={e => filter.onChange(e.target.value)}
              >
                {filter.placeholder !== "" && (
                  <option value="">
                    {filter.placeholder ?? `All ${filter.label.toLowerCase()}s`}
                  </option>
                )}
                {filter.options.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          ),
        )}
      </div>

      {activeFilters && activeFilters.length > 0 && (
        <div className={styles.pills}>
          {activeFilters.map(f => (
            <span key={f.key} className={styles.pill}>
              {f.label}
              <button type="button" onClick={() => onClearFilter?.(f.key)}>
                ×
              </button>
            </span>
          ))}
          <button type="button" className={styles.clearAll} onClick={() => onClearAll?.()}>
            Clear all
          </button>
        </div>
      )}
    </>
  );
}
